import template from './open-popup.vhtml';
import { i18n } from '../../translation.js';

export default {
	template,
	props: {
		popupType: {
			type: String,
			default: '',
		},
		popupData: {
			type: Object,
			required: true,
		},
		translationString: {
			type: String,
			default: 'signupForCourse',
		},
	},
	data() {
		return {
		};
	},
	methods: {
		openPopup() {
			let popupData = {
				type: this.popupType,
				data: this.popupData,
			};
			this.$emit( 'update-popup', popupData );
		},
	},

};


// WEBPACK FOOTER //
// ./assets/_js/components/open-popup/open-popup.js